import { MDSIconKind } from "@/mds/components/icon";
import { SourceKind } from "@/store/sources/types";

export const NOTE_SOURCE_ICON_MAP: Record<SourceKind, MDSIconKind> = {
  EMAIL: MDSIconKind.Envelope,
  TEXT_MESSAGE: MDSIconKind.Message,
  UPLOADED_FILE: MDSIconKind.Document,
  API_REQUEST: MDSIconKind.Merge,
  API_REQUEST_VIA_ZAPIER: MDSIconKind.LogoZapier,
  WEB_CLIP: MDSIconKind.Window,
  AUDIO: MDSIconKind.WaveformLines,
  CALENDAR_EVENT: MDSIconKind.CalendarDay,
};

export const NOTE_SOURCE_CHIP_ICON_MAP: Record<SourceKind, MDSIconKind> = {
  EMAIL: MDSIconKind.Envelope,
  TEXT_MESSAGE: MDSIconKind.Message,
  UPLOADED_FILE: MDSIconKind.Document,
  API_REQUEST: MDSIconKind.Merge,
  API_REQUEST_VIA_ZAPIER: MDSIconKind.LogoZapierSquare,
  WEB_CLIP: MDSIconKind.Window,
  AUDIO: MDSIconKind.WaveformLines,
  CALENDAR_EVENT: MDSIconKind.CalendarDay,
};

export const NOTE_SOURCE_LABEL_MAP: Record<SourceKind, string> = {
  EMAIL: "Email from",
  TEXT_MESSAGE: "Text Messages",
  UPLOADED_FILE: "Uploaded file",
  API_REQUEST: "API Request",
  API_REQUEST_VIA_ZAPIER: "From Zapier",
  WEB_CLIP: "Website",
  AUDIO: "Voice Recording",
  CALENDAR_EVENT: "Meeting",
};
